const getShortenedListItemsLabel = ({
  items,
  emptyText = '',
  showCount = 2
}: {
  items: any[];
  emptyText?: string;
  showCount?: number;
}) => {
  if (!items?.length) return emptyText;
  const visible = items.slice(0, showCount).join(', ');
  const remainingCount = items.length - showCount;
  return remainingCount > 0 ? `${visible}, +${remainingCount}` : visible;
};

const getDropdownOptionsList = (options: string[]) => {
  return options.map((option) => ({
    label: option,
    value: option
  }));
};

export { getShortenedListItemsLabel, getDropdownOptionsList };
